export const DefaultFeErrorCode = 9999;
export const DefaultFeErrorMessage = 'Unknown error';